import React from "react";
import PropTypes from "prop-types";
import "./SoftwareSkill.scss";

const SoftwareSkill = ({logos = []}) => {
  if (!logos || !Array.isArray(logos) || logos.length === 0) {
    // Don't render anything if no logos
    return null;
  }

  return (
    <div className="software-skills-main-div">
      <ul className="dev-icons">
        {logos.map((logo, i) => (
          <li key={i} className="software-skill-inline">
            <i className={logo.fontAwesomeClassname}></i>
            <p>{logo.skillName}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Update PropTypes to allow for default empty array
SoftwareSkill.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      skillName: PropTypes.string.isRequired,
      fontAwesomeClassname: PropTypes.string.isRequired
    })
  )
};

// Set default props
SoftwareSkill.defaultProps = {
  logos: []
};

export default SoftwareSkill;
